export const percentageCalculator = (amount, percentage) => {
    return parseFloat((amount * percentage) / 100);
};

export const getVariantPrice = (selectedVariant) => {
    if (selectedVariant.price) {
        if (selectedVariant.discount_percentage) {
            return parseFloat((selectedVariant.price - percentageCalculator(selectedVariant.price, selectedVariant.discount_percentage)).toFixed(2));
        } else {
            return parseFloat(selectedVariant.price);
        }
    } else {
        return 0.0;
    }
};

// order variants so the cheapest one (after discount) comes first
export const sortVariantsByPrice = (variants) => {
    if (!Array.isArray(variants)) return [];
    return [...variants].sort((a, b) => getVariantPrice(a) - getVariantPrice(b));
};

// images of the given variant, falling back to any other variant that has images
export const getVariantImages = (variant, variants) => {
    if (variant?.images?.length > 0) return variant.images;
    const fallback = (variants ?? []).find((item) => item?.images?.length > 0);
    return fallback ? fallback.images : [];
};

export const getVariantImage = (variant, variants) => getVariantImages(variant, variants)[0] ?? null;

// Product images are full-size originals on BunnyCDN. With Bunny Optimizer
// enabled on the pull zone, ?width= returns a resized (and WebP) copy instead;
// REACT_APP_BUNNY_OPTIMIZER switches that on once the pull zone supports it.
const BUNNY_HOST = "desi-fresh.b-cdn.net";

export const getImageThumbnail = (url, width) => {
    if (!url || process.env.REACT_APP_BUNNY_OPTIMIZER !== "true") return url;
    try {
        const parsed = new URL(url);
        if (parsed.host !== BUNNY_HOST) return url;
        parsed.searchParams.set("width", width);
        return parsed.toString();
    } catch (error) {
        return url;
    }
};

export const getVariantDiscount = (selectedVariant) => {
    if (selectedVariant.price) {
        if (selectedVariant.discount_percentage) {
            return parseFloat(percentageCalculator(selectedVariant.price, selectedVariant.discount_percentage).toFixed(2));
        } else {
            return 0.00;
        }
    } else {
        return 0.0;
    }
};

// tag color by order status
export const TagColorByOrder = (status) => {
    let color;
    switch (status) {
        case "pending":
            color = "var(--color-hotpink)";
            break;
        case "confirmed":
            color = "var(--color-blue)";
            break;
        case "processing":
            color = "var(--color-purple)";
            break;
        case "delivered":
            color = "var(--color-green)";
            break;
        case "cancelled":
            color = "var(--color-red)";
            break;

        default:
            color = "var(--color-hotpink)";
            break;
    }
    return color;
};

// return image path based on nutri score function
export const getNutriScoreImg = (nutriScore) => {
    switch (nutriScore) {
        case "a":
            return "/prod/nutri_a.png";
        case "b":
            return "/prod/nutri_b.png";
        case "c":
            return "/prod/nutri_c.png";
        case "d":
            return "/prod/nutri_d.png";
        case "e":
            return "/prod/nutri_e.png";
        default:
            return "/prod/nutri_b.png";
    }
};

export function getNumberFromString(str) {
    const numericString = str.replace(/[^\d.]/g, "");
    return parseFloat(numericString).toFixed(2);
}

export const getWeightInfo = (variant, finalPrice) => {
    let per_unit_price = 0.0;
    if (variant?.type === "weight_g") {
        per_unit_price = (finalPrice * 1000) / getNumberFromString(variant.value);
    } else if (variant?.type === "weight_kg") {
        per_unit_price = finalPrice / getNumberFromString(variant.value);
    } else if (variant?.type === "weight") {
        if (variant.value.toLowerCase().includes("kg")) {
            per_unit_price = finalPrice / getNumberFromString(variant.value);
        } else {
            per_unit_price = (finalPrice * 1000) / getNumberFromString(variant.value);
        }
    }

    let formatted_str = `${parseFloat(per_unit_price).toFixed(2)}€/kg`;

    if (per_unit_price > 0.0) {
        return formatted_str;
    } else {
        return null;
    }
};
